import { useEffect, useState } from "react";

/**
 * Vráti hodnotu oneskorenú o `ms` — mení sa až keď vstup chvíľu stojí.
 *
 * Používa sa na hypotézu pultu na marže (KOLO 65): pri prepisovaní percent
 * by inak šiel dotaz na každý stisk klávesy. Porovnáva sa cez `JSON`, aby
 * fungovala aj na objektoch — hypotéza je objekt skladaný pri každom
 * rendere, takže referenčná rovnosť by sa nikdy netrafila.
 */
export function useDebounced<T>(hodnota: T, ms = 300): T {
  const [oneskorena, setOneskorena] = useState(hodnota);
  const kluc = JSON.stringify(hodnota);

  useEffect(() => {
    const t = setTimeout(() => setOneskorena(hodnota), ms);
    return () => clearTimeout(t);
    // `kluc` namiesto `hodnota`: obsahová, nie referenčná rovnosť
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kluc, ms]);

  return oneskorena;
}
